import { useQuery } from "@apollo/client";
import { Box, Dialog, DialogContent, useTheme, useMediaQuery } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { GetEventCaptureFormInput } from "../../graphql/queries";
import FormPreview from "../Common/FormPreview";


export default function FormDetails({ open, setOpen, event }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const onClose = () => {
        setOpen(false);
    };

    const { data } = useQuery(GetEventCaptureFormInput, {
        fetchPolicy: "network-only",
        variables: {
            filters: {
                epcisEventId: event?.eventID
            }
        },
        skip: !event?.eventID,
    });


    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" fullScreen={fullScreen} >
            <Box display="flex" justifyContent="flex-end" alignItems="center" sx={{ p: 2 }}>
                <CancelIcon fontSize="medium" onClick={onClose} style={{ cursor: "pointer", }} />
            </Box>
            <DialogContent sx={{ maxHeight: { md: 'calc(var(--app-vh, 1vh) * 70)' }, overflowY: 'auto', overflowX: 'auto', padding: 2 }}>
                {open &&
                    <FormPreview formDetails={data?.traceEventCaptureFormInput?.formData} />
                }
            </DialogContent>
        </Dialog>
    )
}